var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#252525"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Select"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2389_2310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Property 1=select 1",
    filter: "url(#filter0_d_2389_2310)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2389_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -429,
    y: -254,
    width: 473,
    height: 504.388,
    rx: 16.023,
    fill: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 36949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 36948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 36808",
    clipPath: "url(#clip2_2389_2310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Token"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -411,
    y: -17.6172,
    width: 437,
    height: 52.6686,
    rx: 8,
    fill: "#28272C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 36944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.97954 5.71799L9 1.62408L11.0205 5.71799C11.2193 6.12096 11.6038 6.40027 12.0485 6.46489L16.5664 7.12138L13.2972 10.308C12.9754 10.6217 12.8286 11.0736 12.9045 11.5165L13.6763 16.0162L9.63535 13.8917C9.23759 13.6826 8.76241 13.6826 8.36465 13.8917L4.32372 16.0162L5.09547 11.5165C5.17144 11.0736 5.0246 10.6217 4.70281 10.308L1.43363 7.12138L5.95152 6.46489C6.39623 6.40027 6.78066 6.12096 6.97954 5.71799Z",
    stroke: "#92929E",
    strokeWidth: 1.82045
  }))))))), /*#__PURE__*/React.createElement("rect", {
    x: -427.999,
    y: -252.999,
    width: 470.997,
    height: 502.386,
    rx: 15.0216,
    stroke: "#4D4D57",
    strokeWidth: 2.00288
  })), /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Select 2",
    filter: "url(#filter1_d_2389_2310)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2389_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.4062,
    y: -254,
    width: 473,
    height: 504.388,
    rx: 16.023,
    fill: "#1C1C1E"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.4077,
    y: -252.999,
    width: 470.997,
    height: 502.386,
    rx: 15.0216,
    stroke: "#4D4D57",
    strokeWidth: 2.00288
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -448.5,
    y: -273.5,
    width: 1493,
    height: 656,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2389_2310",
    x: -543.031,
    y: -368.031,
    width: 701.061,
    height: 732.452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 57.0154
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.416358 0 0 0 0 0.492902 0 0 0 0 0.894753 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2389_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2389_2310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2389_2310",
    x: -52.6245,
    y: -368.031,
    width: 701.061,
    height: 732.452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 57.0154
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.416358 0 0 0 0 0.492902 0 0 0 0 0.894753 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2389_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2389_2310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2389_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -449,
    y: -274,
    width: 1494,
    height: 657,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2389_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -429,
    y: -254,
    width: 473,
    height: 504.388,
    rx: 16.023,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2389_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 437,
    height: 306,
    fill: "white",
    transform: "translate(-411 -73.6172)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2389_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.4062,
    y: -254,
    width: 473,
    height: 504.388,
    rx: 16.023,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7958d101cd5c900299b11b901201369a.svg";
export { ForwardRef as ReactComponent };